//const API_URL=process.env.REACT_APP_API_URL

export const config = {
  // apiBaseURL:"http://192.168.20.112:5000", 
  // apiBaseURL:"http://192.168.29.27:4000",

  // apiBaseURL: window.location.origin,
  // apiBaseURL: `${API_URL}`,
  apiBaseURL: "https://books.ratnasangh.com",
  apiImageUrl: "https://books.ratnasangh.com",
  // apiBaseURL: "http://localhost:5000",

  // apiImageUrl: "http://localhost:5000"
};

// https://gitlab.com/fintech-development-team/client-mobile-app/library_project.git




// managebook ->

// const location = useLocation();
// const currentPage = location.state?.lastPage || 1;
// const filters = location.state?.lastFilters || {};
// const search_query = location.state?.lastSearch || "";

// navigate("/admin/managebook/view_all_books", {
//   state: {
//     fromEdit: true,
//     lastPage: currentPage,
//     lastFilters: filters,
//     lastSearch: search_query,
//   }
// });



// allbooks ->
// in book_edit_handler -
// navigate(`/admin/managebook/${book_id}`, {
//   state: {
//     fromEdit: true,
//     lastPage: currentPage,
//     lastFilters: filters,
//     lastSearch: search_query,
//   },
// });

// const location = useLocation();
// const defaultFilter = {
//   deptFil: [],
//   subDeptFil: [],
//   authFil: [],
//   pubFil: [],
//   publicationYearFil: [],
//   langFil: [],
// };
// useEffect(() => {
//   if (location.state?.fromEdit) {
//     setCurrentPage(location.state.lastPage ?? 1);
//     setFilters(location.state.lastFilters ?? defaultFilter);
//     setsearch_query(location.state.lastSearch ?? "");
//     fetchbook()
//   } else {
//     setFilters(defaultFilter);
//     fetchbook()
//   }
// }, []);